import { ErrorMessage } from 'components/ui';
import { FC } from 'react';
import DatePicker from 'react-datepicker';
import { FieldError } from 'react-hook-form';
import styled from 'styled-components';
import { globalTheme } from 'styles/global-theme';

interface FieldProps {
  name: string;
  value: Date | undefined;
  onChange: (value: Date | undefined) => void;
  onBlur: () => void;
  ref: (value: any) => void;
}

interface ReactDatePickerProps {
  field: FieldProps;
  fieldStateError?: FieldError;
  dateFormat?: string;
  placeholder?: string;
  clearErrors?: Function;
  autoComplete?: string;
  showIcon?: boolean;
  disablePastDates?: boolean;
  minDate?: Date;
}

const StyledInput = styled.input<{ showIcon: boolean }>`
  width: 100%;
  height: 48px;
  padding: 8px 16px;
  padding-left: ${({ showIcon }) => (showIcon ? '40px' : '16px')} !important;
  font-size: inherit;
  background-color: ${globalTheme.colors.white};
  border: 2px solid ${globalTheme.colors.neutral};
  border-radius: 8px;

  &:focus {
    outline: none;
    border-color: ${globalTheme.colors.neutral};
    box-shadow: none;
  }
`;

const DatePickerWrapper = styled.div`
  width: 100%;
  position: relative;

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__input-container {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .react-datepicker__calendar-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    z-index: 1;
  }
`;

export const ReactDatePicker: FC<ReactDatePickerProps> = ({
  field,
  fieldStateError,
  clearErrors,
  dateFormat = 'dd/MM/yyyy',
  placeholder = 'dd/mm/yyyy',
  autoComplete = 'off',
  showIcon = false,
  disablePastDates = false,
  minDate,
}) => {
  const handleDatePickerChange = (field: any, date: Date | null) => {
    clearErrors && clearErrors(field.name);
    field.onChange(date ? new Date(date) : null);
  };
  return (
    <DatePickerWrapper>
      <DatePicker
        selected={field.value ? new Date(field.value) : undefined}
        placeholderText={placeholder}
        dateFormat={dateFormat}
        maxDate={new Date('9999-12-31')}
        minDate={minDate || (disablePastDates ? new Date() : undefined)}
        ref={field.ref}
        name={`${field.name}-datepicker`}
        onBlur={field.onBlur}
        autoComplete={'off'}
        customInput={
          <StyledInput
            showIcon={showIcon}
            autoComplete={'off'}
            data-lpignore='true'
            data-1p-ignore='true'
            data-form-type='other'
          />
        }
        // showIcon={Boolean(showIcon)}
        // toggleCalendarOnIconClick
        // icon={<BiCalendar />}
        isClearable
        shouldCloseOnSelect
        onChange={(date: Date | null) => {
          handleDatePickerChange(field, date);
        }}
      />
      {fieldStateError !== undefined && (
        <ErrorMessage>{fieldStateError?.message}</ErrorMessage>
      )}
    </DatePickerWrapper>
  );
};
